module.exports = __webpack_public_path__ + "img/04-thumb.4dc38685.png";